<template>
  <div id="home-page">
    <div>
      <admin-emaillog-manage-filter
        :loading_status="loading_status"
        :status="systemList"
        @apply="ApplyFilter"
      ></admin-emaillog-manage-filter>
      <admin-emaillog-manage-detail
        :loading_status="loading_status"
        :email_ac="email_accounting"
        :data="data"
        @view="viewDeatil"
        @submit="submitAction"
      ></admin-emaillog-manage-detail>
    </div>
      <!-- v-if="showDialog" -->
      <!-- v-show="showDialog" -->
    <admin-emaillog-manage-detail-dialog
      :data="selectedRow"
      :temp_data="selectedRow"
      :email_ac="email_accounting"
      :openDialog="openDialog"
      :mainDialog="showDialog"
      @close="closeDialog"
      @fetch="fetch"
      @snack="snack"
    ></admin-emaillog-manage-detail-dialog>

    <token-dialog v-if="tokenExpired"></token-dialog>

    <v-snackbar
      :style="{
        padding: 0,
        margin: '4.5% 0 0 0',
        width: 'inherit'
      }"
      v-model="snackbar"
      :color="color"
      :top="true"
    >
      <!-- :multi-line="multiLine" -->
      <div
        style="font-family: 'Bai Jamjuree', sans-serif;border-radius: 4px;height: 100%;width:400px;"
        class="md-layout"
      >
        <div
          style="border-radius:4px 0 0 4px;height:100%;width:3%;"
          :style="{
            'background-color':
              this.textSnack.status_code == 1 ? '#008525' : '#DA0707'
          }"
        ></div>

        <div style=" width: 97%;">
          <div
            style="
                  padding-left:5px;
                  font-style:italic; 
                  width: 100%;
                  height: 50%;
                  display: flex;
                  justify-content: center;
                  align-items: flex-end;
                  color:#000"
          >
            {{ textSnack.status }}
            <span style="margin:0 0 0 5px;font-weight:bold;">
              "{{ textSnack.user_name }}"
            </span>
          </div>
          <div
            style="height:50%;display: flex;justify-content: center;color:#000"
          >
            เรียบร้อยแล้ว
          </div>
        </div>

        <!-- <div style="padding:0 0 0 10px;display: flex;align-items: center;color:#000;height: 100%;width: 97%;"> 
          {{ textSnack.status }} <span style=";font-weight:bold;"> " {{ textSnack.user_name }} " </span> 
        </div> -->
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import EmailFilter from '@/components/filter/AdminEmailLogFilter'
import detailTable from '@/components/table/AdminEmailLogDetail'
import DetailDialog from '@/components/table/AdminEmailLogManageDetailDialog'
import TokenDetailDialog from '@/components/dialog/TokenDialog'

const d = new Date()
let year = d.getFullYear()
let month = d.getMonth() + 1
month = month > 9 ? month : '0' + month
let startDay = year + '-' + month + '-' + '01'

var dayEnd = d.toLocaleString('default', { day: '2-digit' })
let endDate = year + '-' + month + '-' + dayEnd

export default {
  name: 'admin-user-manage',
  data () {
    return {
      tokenExpired: false,

      // multiLine: true,
      snackbar: false,
      textSnack: '',
      y: 'top',
      color: '#fff',

      loading_status: false,
      data: [],
      status: [],
      selectedRow: [],
      email_accounting:[],
      showDialog: false,
      openDialog: false,
      dialogDetail: true,
      systemList: [
        { code: 'all', title: 'All' },
        { code: 'fail', title: 'Fail' },
        { code: 'success', title: 'Success' }
      ],
      filterData: {

        purchase_id:'',
        start_order_date: new Date(startDay).toISOString().slice(0, 10),
        end_order_date: endDate,
        cus_mail: '',


       
      },
    }
  },
  computed: {
    loading () {
      return this.$store.getters.isLoading
    }
  },
  watch: {},
  methods: {
    ApplyFilter (val) {
      this.filterData = val
      this.fetch()
    },
    viewDeatil (val) {
      let res1 = 
            {
            id:'',
            event:'getactive',
            acc_email:'',
            acc_name:'',
            is_active:''}

      this.$store
        .dispatch('getAccountEmail', res1)
        .then(res => {
          console.log(res)
          this.email_accounting = res
          this.loading_status = false
        })
        .catch(error => {
          if (error.response.status == 401) {
            sessionStorage.removeItem('user_profile'); 
            sessionStorage.removeItem('token_seesion');
            this.tokenExpired = true
            console.log('Error 401')
          }
        })
        
      let res = 
         [ {
            purchase_id : val.purchase_id,
            order_date  :val.order_date,
            change_address : val.change_address,
            cus_email : val.cus_email,
            df_mail: val.cus_email,
            checked_acc : val.checked_acc,
            checked_cus : val.checked_cus,
            inp_mail:false
            
          }]
      this.selectedRow = res
      this.showDialog = true
      // console.log('viewDeatil ==> ', val)
    },
    closeDialog (val) {
      this.showDialog = false
      // console.log('closeDialog ==> ', val)
    },
    submitAction (val) {
      this.$router.push('/AdminCreateAccount')
    },
    fetch () {
      let arr = []
      this.loading_status = true
      this.$store
        .dispatch('getTransMail', this.filterData)
        .then(res => {
          console.log(res)
          this.data = res.success.data
          this.loading_status = false
        })
        .catch(error => {
          if (error.response.status == 401) {
            sessionStorage.removeItem('user_profile');
             sessionStorage.removeItem('token_seesion');
            this.tokenExpired = true
            console.log('Error 401')
          }
        })
    },
    snack (param) {
      this.textSnack = param
      this.snackbar = param.show
      this.fetch()
    }
  },
  created () {
    if (
      this.$store.getters.user_profile === null &&
      sessionStorage.getItem('user_profile') === null
    ) {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/')
      })
    } else if (sessionStorage.getItem('user_profile') !== null) {
      let data = JSON.parse(sessionStorage.getItem('user_profile'))
      if (data.user_role == 'supplier') {
        this.$router.push('/' + 'home')
      } else {
        this.fetch()
        // console.log('ADmin')
      }
    }
  },
  components: {
    'admin-emaillog-manage-filter': EmailFilter,
    'admin-emaillog-manage-detail': detailTable,
    'admin-emaillog-manage-detail-dialog': DetailDialog,
    'token-dialog': TokenDetailDialog
  },
  mounted () {}
}
</script>
<style>
.v-snack__content {
  padding: 0;
  height: 70px;
}
</style>
